export function PricingPage() {
  return (
    <div className="pricing-page">
      <h1>Pricing</h1>
      {/* TODO: Implement pricing page */}
    </div>
  );
}

